import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetReports = () =>
  useMutation({
    mutationFn: (data) => client(`reports/service/calls`, { data }),
  });

export const useGetAllCallsReports = () =>
  useMutation({
    mutationFn: (data) => client(`reports/all/calls`, { data }),
  });
